import { HttpClient, HttpHeaders } from '@angular/common/http';

import { HttpUtils } from '../utils/httpUtils';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Volume } from '../model/volume';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';

@Injectable()
export class VolumeService {

    constructor(private http: HttpClient) {
    }

    save(vol: Volume, timeStamp: string, executionId: number): Observable<any> {
        const url = environment.airUrl + `/execution/volume/create/${executionId}`;

        const headers = new HttpHeaders({
            timeStamp
        });
        return this.http.post(url, vol, { headers }).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
    }

    update(vol: Volume, timeStamp: string, executionId: number): Observable<any> {
        const url = environment.airUrl + `/execution/volume/${vol.id}/${executionId}`;

        const headers = new HttpHeaders({
            timeStamp
        });
        return this.http.put(url, vol, { headers }).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
    }

    delete(vol: Volume, timeStamp: string, executionId: number): Observable<any> {
        const url = environment.airUrl + `/execution/volume/${vol.id}/${executionId}`;

        const headers = new HttpHeaders({
            timeStamp
        });
        return this.http.delete(url, { headers }).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
    }

}
